/* TRNK& &NEWSFEED: a compact ticker of &approved cards from the research desk (custom-feed.hbs). */
(function () {
    var page = document.querySelector('.trnk-feed-page');
    if (!page) return;

    // The ampersand in the page title is green, like the brand.
    var heading = page.querySelector('.gh-article-title');
    if (heading && !heading.querySelector('.trnk-amp')) {
        Array.prototype.slice.call(heading.childNodes).forEach(function (child) {
            if (child.nodeType !== 3 || child.nodeValue.indexOf('&') === -1) return;
            var fragment = document.createDocumentFragment();
            child.nodeValue.split('&').forEach(function (part, index) {
                if (index) {
                    var amp = document.createElement('span');
                    amp.className = 'trnk-amp';
                    amp.textContent = '&';
                    fragment.appendChild(amp);
                }
                if (part) fragment.appendChild(document.createTextNode(part));
            });
            heading.replaceChild(fragment, child);
        });
    }

    var feed = page.querySelector('[data-trnk-feed]');
    if (!feed || !window.fetch) return;

    function node(tag, className, text) {
        var el = document.createElement(tag);
        if (className) el.className = className;
        if (text) el.textContent = text;
        return el;
    }

    function safeLink(value) {
        try {
            var url = new URL(value);
            return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
        } catch (e) {
            return '';
        }
    }

    function czechDate(value) {
        var parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
        return parts ? Number(parts[3]) + '. ' + Number(parts[2]) + '. ' + parts[1] : 'Bez data';
    }

    function count(n) {
        return n + (n === 1 ? ' odkaz' : n >= 2 && n <= 4 ? ' odkazy' : ' odkazů');
    }

    function status(text) {
        feed.replaceChildren(node('p', 'trnk-feed-status', text));
        feed.setAttribute('aria-busy', 'false');
    }

    function row(item) {
        var href = safeLink(item.link);
        var li = node('li', 'trnk-ticker-item');
        var link = node(href ? 'a' : 'div', 'trnk-ticker-link');
        if (href) {
            link.href = href;
            link.target = '_blank';
            link.rel = 'noopener';
        }
        var main = node('span', 'trnk-ticker-main');
        main.appendChild(node('span', 'trnk-ticker-title', item.title || ''));
        if (item.comment) main.appendChild(node('span', 'trnk-ticker-comment', item.comment));
        link.appendChild(main);
        link.appendChild(node('span', 'trnk-ticker-host', item.host ? item.host + (href ? ' ↗' : '') : ''));
        li.appendChild(link);
        return li;
    }

    fetch(feed.getAttribute('data-trnk-feed'), {credentials: 'omit'})
        .then(function (response) {
            if (!response.ok) throw new Error('feed ' + response.status);
            return response.json();
        })
        .then(function (data) {
            var items = (data && data.items) || [];
            if (!items.length) {
                status('Zatím tu nic není. Brzy přibudou první odkazy.');
                return;
            }
            // Group by day, newest first, like a wire.
            var days = [];
            var byDay = {};
            items.forEach(function (item) {
                var key = item.date || '';
                if (!byDay[key]) {
                    byDay[key] = [];
                    days.push(key);
                }
                byDay[key].push(item);
            });
            days.sort(function (a, b) {
                return b.localeCompare(a);
            });
            var fragment = document.createDocumentFragment();
            days.forEach(function (key) {
                var day = node('section', 'trnk-ticker-day');
                var head = node('h2', 'trnk-ticker-date');
                head.appendChild(node('span', '', czechDate(key)));
                head.appendChild(node('span', 'trnk-ticker-count', count(byDay[key].length)));
                day.appendChild(head);
                var list = node('ol', 'trnk-ticker-list');
                byDay[key].forEach(function (item) {
                    list.appendChild(row(item));
                });
                day.appendChild(list);
                fragment.appendChild(day);
            });
            feed.replaceChildren(fragment);
            feed.setAttribute('aria-busy', 'false');
        })
        .catch(function () {
            status('Odkazy se teď nepodařilo načíst. Zkus to prosím za chvíli.');
        });
}());
